"use client";

import * as React from "react";

const supported = () =>
  typeof window !== "undefined" && typeof window.matchMedia === "function";

/**
 * Tracks whether a CSS media query matches and re-renders when
 * the match state changes. Returns `false` on the server and
 * until hydration is complete.
 *
 * Use this only for behavior that cannot be implemented with CSS.
 */
export function useMediaQuery(query: string) {
  const subscribe = React.useCallback(
    (onChange: () => void) => {
      if (!supported()) return () => {};
      const list = window.matchMedia(query);
      list.addEventListener("change", onChange);
      return () => list.removeEventListener("change", onChange);
    },
    [query],
  );

  const getSnapshot = React.useCallback(
    () => (supported() ? window.matchMedia(query).matches : false),
    [query],
  );

  return React.useSyncExternalStore(subscribe, getSnapshot, () => false);
}
